import {
  Component, OnInit, OnDestroy, AfterViewInit, DoCheck, OnChanges, SimpleChanges, Input,
  ViewChild, ElementRef, ComponentFactoryResolver, ComponentFactory, ViewContainerRef, ReflectiveInjector, ComponentRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FormDoneService } from '../../_services/form-done.service';
import { PartnerQuestionsService } from '../../_services/partner-questions.service';
import { FlexQuestionsService } from '../../_services/flex-questions.service';
import { AuthenticationService } from '../../_services/index';

import { SubsectionComponent } from '../questionnaire/elements/subsection.component';
import { TextQuestiontypeComponent } from '../questionnaire/elements/text.questiontype.component';
import { BooleanQuestiontypeComponent } from '../questionnaire/elements/boolean.questiontype.component';
import { AddressQuestiontypeComponent } from '../questionnaire/elements/address.questiontype.component';
import { SectionPaneComponent } from '../questionnaire/elements/section.pane.component';
import { SidebarComponent } from '../questionnaire/elements/sidebar.component';
import { CommunicationPreferenceComponent } from '../questionnaire/elements/communicationpref.questiontype.component';
import { RacialBackgroundComponent } from '../questionnaire/elements/racial.background.component';
import { EthnicBackgroundComponent } from '../questionnaire/elements/ethnic.background.component';
import { CareerAcademyComponent } from '../questionnaire/elements/career.academy.component';
import { PhoneComponent } from '../questionnaire/elements/phone.questiontype.component';
import { CheckmarkWithItemsComponent } from '../questionnaire/elements/checkmark.with.items.component';
import { AcademicProgramsComponent } from '../questionnaire/elements/academic.programs.component';
import { PDFUploadComponent } from '../questionnaire/elements/pdf.upload.component';
import { DropdownQuestiontypeComponent } from '../questionnaire/elements/dropdown.questiontype.component';
import { CheckboxCollectionComponent } from '../questionnaire/elements/checkbox.collection.component';
import { AcademicMajorComponent } from '../questionnaire/elements/academicmajor.questiontype.component';
import { ProfessionalGoalComponent } from '../questionnaire/elements/professionalgoal.questiontype.component';
import { HighschoolComponent,CollegeComponent } from '../questionnaire/elements/school.questiontype.component';
import { TextareaQuestiontypeComponent } from '../questionnaire/elements/textarea.questiontype.component';
import { StudentInfoService } from '../../_services/student-info.service';

declare var $: any;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers: [FormDoneService, PartnerQuestionsService, FlexQuestionsService, AuthenticationService]
})
export class ProfileComponent implements OnInit, AfterViewInit, DoCheck, OnDestroy {
  @ViewChild("sectionContainer", { read: ViewContainerRef }) sectionContainer: ViewContainerRef;
  @ViewChild("sidebarContainer", { read: ViewContainerRef }) sidebarContainer: ViewContainerRef;

  public currentUser: any;
  public selectedItem = '';
  public completed = 0;
  public pendingForm;
  public resumeEditForm;
  public objData: any= {};

  adult:boolean = true;
  clickcheck:boolean = false;
  complete:boolean=false;
  digitalForm: FormGroup;
  digitalsignFileget;
  digitalsign_link;
  error;
  errorFlag: boolean=false;
  errorFlag1:boolean=false;
  errorMessage:string='';
  errorMessage1:string='';
  filesToVerify:any[];
  finalSubmit;
  formcheck:boolean=false;
  getdataSub: Subscription;
  hasAlreadyApplied:boolean=false;
  hasSar:boolean=false;
  requireSar:boolean=false;
  lastInserted:number;
  listeners:Subscription[];
  loading:boolean=false;
  partnerAppExists:boolean=false;
  partnername:string='';
  partnerid:number;
  questiontab = false;
  questionTabName: String;
  recommendationFileget;
  recommendation_link;
  required:boolean=true;  // I don't think it ever gets set to anything else.
  school_year:string='current';
  sections:ComponentRef<any>[];
  showCalSarUploadTag:boolean=false;
  sidebars:ComponentRef<any>[];
  submitting:boolean=false;
  successMessage:string='';
  successMessage1:string='';
  today:string='';

  constructor(
    private router: Router,
    private stdapi: StudentInfoService,
    private activatedRoute: ActivatedRoute,
    private api: FormDoneService,
    private formapi: PartnerQuestionsService,
    private flexapi: FlexQuestionsService,
    private loginservice: AuthenticationService,
    private resolver: ComponentFactoryResolver
    
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.sections = [];
    this.sidebars = [];
    this.listeners= [];
  }

  ngOnInit() {
    var now:Date,dd:string,mm:string,yyyy:string,init={};

    this.getQuestionsData();
    this.listeners.push(this.activatedRoute.params.subscribe((params)=>{
      this.selectedItem=params.sectionName;
      if((this.selectedItem=='complete-application') && (!this.hasAlreadyApplied)) {

        // JIT calculation accounts for students beginning before midnight, and submitting after midnight.
        now=new Date();
        dd=('0'+now.getDate()).slice(-2);
        mm=('0'+(now.getMonth()+1)).slice(-2);
        yyyy=''+now.getFullYear();
        this.today=mm+'/'+dd+'/'+yyyy;

        this.flexapi.getFinalSummary().then(
          (SUCCESS)=>{
            this.hasSar=SUCCESS.hasSar;
            this.partnername=SUCCESS.partnername;
            this.filesToVerify=SUCCESS.filesToVerify;

            if(this.hasSar || !this.requireSar) {
              this.openDialog();
            }
          },
          (FAILURE)=>{
            console.log('failure',FAILURE);
            this.hasAlreadyApplied = true;
          }
        );
      }
    }));
    

    init['studentName']=new FormControl('',[Validators.required]);
    init['date']=new FormControl('');
    init['dob']=new FormControl('');
    init['parentName']=new FormControl('');
    init['parentSignature']=new FormControl('');
    init['studentSignature']=new FormControl('');
    init['undereighteen']=new FormControl('');

    this.digitalForm=new FormGroup(init);

  }

  ngOnDestroy() {
    var C;
    if (this.getdataSub)  {
      this.getdataSub.unsubscribe();
    }
    while(C=this.sections.pop()) {
      C.destroy();
    }
    while(C=this.sidebars.pop()) {
      C.destroy();
    }
    while(C=this.listeners.pop()) {
      C.unsubscribe();
    }
  }

  under18() {
    let undereighteen  = this.digitalForm.controls.undereighteen.value;
    this.adult = !undereighteen;
    this.digitalForm.controls.date.setValue(undereighteen ? this.today : '');
    if(!undereighteen){
      this.digitalForm.controls.parentName.setValue('');
    }
  }

  agreeTerm1(){
    // No op
  }

  agreeTerm2(){
    // No op
  }
  onSubmit2() {
    this.loading = true;
    const digitalForm = this.digitalForm.value;

    const body = JSON.stringify({
      studentName: this.digitalForm.controls.studentName.value,
      dob: this.today,
      undereighteen: this.digitalForm.controls.undereighteen.value,
      studentSignature: this.digitalForm.controls.studentSignature.value,
      date: this.digitalForm.controls.date.value,
      parentSignature: this.digitalForm.controls.parentSignature.value,
      parentName: this.digitalForm.controls.parentName.value,
      partnerid:this.partnerid
    });

    this.formapi.postDigitalData$(body).subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        this.errorFlag1 = false;
        const response = JSON.parse(data._body);
        this.successMessage1 = response.message;
        this.loading = false;
        //this.dialogRef.close(response.lastInserted);
        this.lastInserted = response.lastInserted;
        //this.dialogRef.close(this.lastInserted);
        this.onFinalSubmit();
        $('#Beforesubmitting2').modal('hide');
      },
      error => {
        this.submitting = false;
        this.errorFlag1 = true;
        const errordata = JSON.parse(error._body);
        if (errordata.success === 0) {
          this.errorMessage1 = errordata.message;
          this.errorFlag1 = true;
          this.loading = false;
        }
      },
    );
  }

  openDialog() {
    // $('#Beforesubmitting1').modal('show');
    $('#Beforesubmitting2').modal('show');
  }

  openDialog2() {
    // $('#Beforesubmitting1').modal('hide');
    $('#Beforesubmitting2').modal('show');
  }

  onFinalSubmit() {
    this.submitApplication().then(
      (success)=>{
          window.scrollTo(300, 500);
          setTimeout(()=>{
            this.router.navigate(['/user-dashboard']);
          },5000);
      },
      (failure)=>{
      }
    );
  }

  handleUserUpdated() {
    console.log('handleUserUpdated');
    this.getdataSub = this.api.getFormData$()
    .subscribe(responsedata => {
      const formdata = responsedata.data;
      console.log(formdata);
    });
  }

  ngDoCheck() {
  }

  ngAfterViewInit() {
    $('.profile-tabs').click(function () {
      const p = $(this).parents('.profile').first();
      p.find('.profile-tabs').removeClass('highlight');
      $(this).addClass('highlight');
    });
    function sticky_relocate() {

      if( typeof $('#footer').offset()!= 'undefined'){

        const window_top = $(window).scrollTop();
        const footer_top = $('#footer').offset().top;
        const div_top = $('#sticky-anchor').offset().top;
        const div_height = $('#sidebar').height();
        const list_width = $('.tab-column-box').width();
        const padding = 40;  // tweak here or get from margins etc
        if (window_top + div_height > footer_top - padding) {
          $('#sidebar').css({top: (window_top + div_height - footer_top + padding) * -1});
        } else if (window_top > div_top) {
          $('#sidebar').addClass('stick');
          $('ul.profile li').css('width', list_width + 'px');
          $('#sidebar').css({top: 140 + 'px'});
        } else {
          $('#sidebar').removeClass('stick');
        }

      }

    }
    $(function () {
        $(window).scroll(sticky_relocate);
        sticky_relocate();
    });
  }

  /*
   * data.questions: Preorder traversal of the question tree, in nested-set notation
   */
  buildQuestionTree(data) {
    var level=0;
    var ix=0;
    var pendingHider=null;
    var hideReveal=(controller,controlled)=>{
      this.listeners.push(controller.onChange.subscribe((reveal)=>{
        controlled.disabled=!reveal;
      }));
      controlled.disabled=!controller.value;
    };

    var build=(rgt,container)=>{
      level++;
      while((ix<data.questions.length) && (data.questions[ix].lft < rgt)) {
        var factory:ComponentFactory<any>;
        var instance,sidebar,slug;

        if((data.questions[ix].rgt-data.questions[ix].lft) > 1) {
          // This is a container with a header.
          if(level==1) {
            // This is a top-level container
            slug=data.questions[ix].prompt.replace(/[^A-Za-z0-9]/g,'-').replace(/(-)+/g,'-').replace(/(^-|-$)/g,'').toLowerCase();
            factory=this.resolver.resolveComponentFactory(SectionPaneComponent);
            instance=container.addChild(factory,data.questions[ix]);
            instance.slug=slug;

            factory=this.resolver.resolveComponentFactory(SidebarComponent);
            sidebar=this.addSidebar(factory,data.questions[ix]);
            sidebar.slug=slug;
            instance.sidebar=sidebar;
          } else {
            // This is a sub-container
            factory=this.resolver.resolveComponentFactory(SubsectionComponent);
            instance=container.addChild(factory,data.questions[ix]);
          }
          if (!!pendingHider) {
            hideReveal(pendingHider,instance);
            pendingHider=null;
          }
          ix++;
          build(data.questions[ix-1].rgt,instance);
        } else {
          // This is a form component.
          switch(data.questions[ix].answertypelabel) {
            case 'Address':
              factory=this.resolver.resolveComponentFactory(AddressQuestiontypeComponent);
              break;
            case 'Yes/No':
              factory=this.resolver.resolveComponentFactory(BooleanQuestiontypeComponent);
              break;
            case 'Communication Preference':
              factory=this.resolver.resolveComponentFactory(CommunicationPreferenceComponent);
              break;
            case 'Racial Background':
              factory=this.resolver.resolveComponentFactory(RacialBackgroundComponent);
              break;
            case 'Ethnic Background':
              factory=this.resolver.resolveComponentFactory(EthnicBackgroundComponent);
              break;
            case 'Career Academy':
              factory=this.resolver.resolveComponentFactory(CareerAcademyComponent);
              break;
            case 'Phone':
              factory=this.resolver.resolveComponentFactory(PhoneComponent);
              break;
            case 'Extracurricular Activities':
            case 'Industry Work Experience':
              factory=this.resolver.resolveComponentFactory(CheckmarkWithItemsComponent);
              break;
            case 'Academic Programs':
              factory=this.resolver.resolveComponentFactory(AcademicProgramsComponent);
              break;
            case 'PDF Upload with Digital Signature':
            case 'PDF Upload':
              factory=this.resolver.resolveComponentFactory(PDFUploadComponent);
              break;
            case 'Drop-Down':
              factory=this.resolver.resolveComponentFactory(DropdownQuestiontypeComponent);
              break;
            case 'Checkbox Group':
              factory=this.resolver.resolveComponentFactory(CheckboxCollectionComponent);
              break;
            case 'Academic Major':
              factory=this.resolver.resolveComponentFactory(AcademicMajorComponent);
              break;
            case 'Professional Goal':
              factory=this.resolver.resolveComponentFactory(ProfessionalGoalComponent);
              break;
            case 'High School':
              factory=this.resolver.resolveComponentFactory(HighschoolComponent);
              break;
            case 'College':
              factory=this.resolver.resolveComponentFactory(CollegeComponent);
              break;
            case 'Text - Multiple Lines':
              factory=this.resolver.resolveComponentFactory(TextareaQuestiontypeComponent);
              break;
            default:
              factory=this.resolver.resolveComponentFactory(TextQuestiontypeComponent);
              break;
          }
          instance=container.addChild(factory,data.questions[ix]);

          if(!!data.questions[ix].hidereveal) {
            pendingHider=instance;
          } else if (!!pendingHider) {
            hideReveal(pendingHider,instance);
            pendingHider=null;
          }
          ix++;
        }
      }
      level--;
    }
    while(ix < data.questions.length) {
      build(data.questions[ix].rgt,this);
    }
  }

  addChild(factory,itemdata){
    var componentRef:ComponentRef<any>=this.sectionContainer.createComponent(factory);
    this.sections.push(componentRef);
    for(let i in itemdata) {
      componentRef.instance[i]=itemdata[i];
    }
    ((sectionOrder)=>{
      this.listeners.push(componentRef.instance.next.subscribe((dummy)=>{
        if(sectionOrder < (this.sections.length - 1)) {
          this.sidebars[sectionOrder+1].instance['onNav']();
        }
      }));
    })(this.sections.length - 1);
    return componentRef.instance;
  }

  addSidebar(factory,itemdata){
    var componentRef:ComponentRef<any>=this.sidebarContainer.createComponent(factory);
    this.sidebars.push(componentRef);
    for(let i in itemdata) {
      componentRef.instance[i]=itemdata[i];
    }
    this.listeners.push(componentRef.instance['completeChange'].subscribe(()=>{
      this.markWhetherComplete();
    }));
    return componentRef.instance;
  }

  getQuestionsData() {
    var sub;
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    const countLength = parts.length;
    const subdomain = parts.shift();
    if (countLength === 2) {
      sub=this.flexapi.getQuestionsData$().subscribe(
        responsedata => {
          sub.unsubscribe();
          this.partnerid=responsedata['partnerid'];
          this.requireSar=responsedata['require_sar'];
          this.partnerAppExists=responsedata['partnerAppExists'];
          this.hasAlreadyApplied=responsedata['hasAlreadyApplied'];
          this.school_year=responsedata['school_year'] || 'current';
          this.buildQuestionTree(responsedata);
          this.markWhetherComplete();
        },
        error => {
          sub.unsubscribe();
          console.log(error);
        },
      );
    }
  }


  markWhetherComplete(){
    setTimeout(()=>{
      this.complete=this.sidebars.every((ref)=>{
        return ref.instance.complete;
      });
      var completedper=0;
      this.sidebars.forEach((ref)=>{
        if(ref.instance.complete) {
          completedper++;
        }
      });

      const perResult = JSON.parse(localStorage.getItem('persentcomplete'));
      this.completed = Math.floor((completedper/this.sidebars.length)*100);   
      if(completedper != perResult){
        localStorage.setItem('persentcomplete', JSON.stringify(completedper));
        this.updateCompleteStatusPer(this.completed);
      }      
    },0);
  }

  updateCompleteStatusPer(completed){
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    const subdomain = parts.shift();
    this.currentUser.personid;
    this.objData= JSON.stringify({
      completed: completed,
      personid: this.currentUser.personid,
      partnername: subdomain,
    });

    console.log(this.objData);
    this.loading = true;
    this.stdapi.updateCompletedPer$(this.objData)
    .subscribe(
      data => {
        this.error = false;
        this.errorFlag = false;
        this.loading = false;
        setTimeout(() => {
        }, 2000);
        //this.dialogRef.close(data);
      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        this.loading = false;
        setTimeout(() => {
        }, 2000);
        //this.dialogRef.close(error);
      }
    );
  }

  completeApplication(evt?:any){
    evt && evt.preventDefault && evt.preventDefault();
    this.router.navigateByUrl('/profile/complete-application');
    window.scrollTo(300, 500);
  }

  submitApplication(evt?:any){
    evt && evt.preventDefault && evt.preventDefault();
    var sub;
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    const countLength = parts.length;
    const subdomain = parts.shift();
    if(this.completed == 100){
      return new Promise((resolve,reject)=>{
        sub=this.flexapi.submitApplication({
          dsrdid:this.lastInserted
        }).subscribe(
          responsedata => {
            sub.unsubscribe();
            this.hasAlreadyApplied=true;
            resolve(true);
          },
          error => {
            sub.unsubscribe();
            reject(error);
          },
        );
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/profile.component.ts